import useCommonStore from 'www/vue_components/common/TheFilters/lpu/stores/useCommonStore'
import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'

function getPlaceLabel({ place, isChip }: { place: Filters['place'], isChip?: boolean }) {
  if (place?.name) {
    return place.name
  }

  const commonStore = useCommonStore()

  if (isChip) {
    return commonStore.lpuList.hasMetro
      ? 'Метро'
      : ''
  }

  return commonStore.lpuList.hasMetro
    ? 'Метро, район'
    : 'Район'
}

export default getPlaceLabel
